import { useNavigate } from "react-router-dom";
import axios from "axios";

export const useRegister = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const register = (user) => {
    // const endpoint = `${API_URL}/api/users/`;
    const endpoint = `/api/users/`;
    const queries = { username: user.username, password: user.password };
    axios
      .post(endpoint, queries)
      .then((res) => {
        if (Object.keys(res.data).length > 0) {
          navigate("/registersucceeded", { state: { name: user.username } });
        } else {
          console.error("登録失敗");
          navigate("/registerfailed", { state: user });
        }
      })
      .catch((e) => {
        console.error(e);
        console.error("e.response", e.response?.data);
        navigate("/registerfailed", { state: user });
      });
  };
  return { register };
};
